export const productShortName = 'Hydrogen Energy & Fuel Cells — Professional Edition™';
export const productBrand = 'Hydrogen Energy & Fuel Cells';
export const productEdition = 'Professional Edition™';
export const productImage = 'https://cdn.magicpatterns.com/uploads/3TrPqGWnR2SJFaEWg1KduY/MOCKUP_11.39.29_a._m..png';

export const checkoutUrl = 'https://hydrogen-energy-fuel-cells.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70.00';

export const closingLines = [
  'No more confusion about hydrogen production pathways',
  'No more uncertain technical explanations to clients',
  'No more struggling with electrolysis and fuel cell concepts',
  'No more gaps in understanding hydrogen infrastructure',
  "No more limited career advancement because technical knowledge isn't documented",
];
